import { render } from "./AboutCard.vue?vue&type=template&id=326c699e"
import script from "./AboutCard.vue?vue&type=script&lang=js"
export * from "./AboutCard.vue?vue&type=script&lang=js"

import "./AboutCard.vue?vue&type=style&index=0&id=326c699e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__